<script>
    import Dashboard from "../../Models/dashboardModel";
    import QuestionLibrary from "../../Models/QuestionLibraryModel";

    import Loader from '../Loader.svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import {debounce} from "lodash-es";

    import { onMount } from "svelte";

    import { groupBy } from "lodash-es";

    import Fa from 'svelte-fa';
    import {faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";

    export let params;

    let  sortFields, formFields;
    let dashboard_model, dashboard;
    let unCollapsedControls = {}

    let dragging = false;

    let libraries;

    let library_map = {}
    let controls = {};

    let searchText = "";
    let hiddenControls = {};

    function filtercontrols(searchText, libraries) {
        if (!libraries) return;
        let lowerSearch = searchText.toLowerCase();

        let results = {};
        for (let library of libraries) {
            let hide_library = true;
            for (let category of library.categories) {
                let hide_category = true;
                for (let subcategory of category.subcategories) {
                    let hide_subcategory = true;
                    for (let control of subcategory.controls) {
                        let hide_control = true;

                        if (
                            control.details.control_number.toLowerCase().includes(lowerSearch) ||
                            control.details.name.toLowerCase().includes(lowerSearch) ||
                            control.details.text.toLowerCase().includes(lowerSearch)
                        ) {
                            hide_library = false;
                            hide_category = false;
                            hide_subcategory = false;
                            hide_control = false;
                        }

                        results[control.id] = hide_control;
                    }

                    results[subcategory.id] = hide_subcategory;
                }

                results[category.id] = hide_category;
            }

            results[library.id] = hide_library;
        }

        hiddenControls = results;
    }

    const debounceFilter = debounce(filtercontrols, 150)


    async function getQuestionLibraries() {
        let library_list = await QuestionLibrary.getListStatic();

        let results = [];

        for (let library of library_list) {
            library_map[library._id] = library;
            results.push(QuestionLibrary.getStatic(library._id));
        }

        libraries = await Promise.all(results);

        for (let library of libraries) {
            for (let category of library.categories) {
                for (let subcategory  of category.subcategories) {
                    for (let control of subcategory.controls) {
                        controls[control.details.child_id] = control.details;
                    }
                }
            }
        }
    }

    function dragStart(evt, library, control) {
        let map_data = {
            library_id: library.id,
            control_id: control.details.child_id
        }
        evt.dataTransfer.setData("text/json", JSON.stringify(map_data));
        evt.dataTransfer.setDragImage(evt.target, 0, 0);

        dragging = true;

        return true;
    }

    function dragEnd(evt) {
        dragging = false;

        return true;
    }

    function dragEnter(evt, control) {

        evt.target.classList.add('has-background-primary-light');
        return false;
    }

    function dragLeave(evt, control) {
        evt.target.classList.remove('has-background-primary-light');
    }

    function dragDrop(evt, item) {
        let map_data = JSON.parse(evt.dataTransfer.getData("text/json"));

        if (!item.library_mappings) {
            item.library_mappings = [map_data]
        } else {
            item.library_mappings.push(map_data);
        }

        dashboard_model.updateItem(item).then(() => notifier.success("Mapping Added"));

        evt.target.classList.remove('has-background-primary-light');
    }

    function removeMapping(item, mapping) {
        item.library_mappings = item.library_mappings.filter((m) => m != mapping)
        dashboard_model.updateItem(item).then(() => notifier.success("Mapping Removed"));

    }

    $: debounceFilter(searchText, libraries)

    onMount(() => {
        dashboard_model = new Dashboard(params.id);

        const unsub = dashboard_model.store.subscribe((lib) => {
            if (!lib) {
                return;
            }

            dashboard = lib;

            console.log(dashboard);

            formFields = [
                {
                    "name": "Name",
                    "label": "Name"
                }
            ];
            sortFields = [{
                "field": "Name",
                "label": "Name"
            }];
            for (let field of dashboard.details.fields) {
                let formField = {
                    name: field.name,
                    label: field.name,
                    type: field.type,
                    required: field.required
                };
                if (field.type == "select") {
                    formField.choices = {
                        static: field.options
                    }
                    formField.dflt = field.options[0]
                }
                formFields.push(formField)

                if (field.show_in_table != undefined && field.show_in_table) {
                    sortFields.push({
                        field: field.name,
                        label: field.name
                    })
                }
            }

            // tell svelte it changed
            formFields = formFields;
            sortFields = sortFields;

        });

        getQuestionLibraries();

        return unsub;
    })
</script>

<Loader loading={!(dashboard && libraries)}>
    <div class="container is-fluid" class:dragging>
        <div class="columns">
            <div class="column scroll">
                <h1 class="title is-1">{dashboard.details.name}</h1>
                <div class="columns is-multiline">
                    {#each dashboard.items as item (item.item_id)}
                        <div
                            class="column is-3 card"
                            on:dragenter|self={(evt) => dragEnter(evt, item)}
                            on:dragleave|self={dragLeave}
                            on:dragover|preventDefault={()=>  false}
                            on:drop|self|stopPropagation|preventDefault={evt => dragDrop(evt, item)}
                        >
                            <p class="title is-3">{item.Name}</p>
                            <hr>
                            {#if item.library_mappings}
                                {#each Object.entries(groupBy(item.library_mappings, "library_id")) as [library_id, mappings]}
                                    <h3 class="title is-4">{library_map[library_id].name}</h3>
                                    <div class="tags mappings">
                                        <div class="field is-grouped is-grouped-multiline">
                                            {#each mappings as mapping}
                                                {#if controls[mapping.control_id]}
                                                    <div class="control">
                                                        <div class="tags has-addons" title={controls[mapping.control_id].text}>
                                                            <span class="tag">{controls[mapping.control_id].control_number} {controls[mapping.control_id].name}</span>
                                                            <span class="tag is-light is-delete pointer" on:click={removeMapping(item, mapping)}></span>
                                                        </div>
                                                    </div>
                                                {:else}
                                                    <div class="control">
                                                        <div class="tags has-addons">
                                                            <span class="tag is-light is-danger">Question no longer exists</span>
                                                            <span class="tag is-light is-delete pointer" on:click={removeMapping(item, mapping)}></span>
                                                        </div>
                                                    </div>
                                                {/if}
                                            {/each}
                                        </div>
                                    </div>
                                {/each}
                            {/if}
                        </div>
                    {/each}
                </div>
            </div>
            <div class="column is-3">
                <aside class="menu scroll libs">
                    <h2 class="title is-2">Question Libraries</h2>
                    <div class="field search">
                        <p class="control has-icons-left has-icons-right">
                            <input class="input is-rounded" type="text" placeholder="Search" bind:value={searchText}>
                            <span class="icons">
                                <span class="icon is-right">
                                    <button class="delete" aria-label="delete" on:click={() => searchText = ""}></button>
                                </span>
                                <span class="icon is-small is-left magnifying-glass">
                                    <Fa icon={faMagnifyingGlass} />
                                </span>
                            </span>
                        </p>
                    </div>
                    <ul class="menu-list">
                        {#each libraries as library (library.id)}
                            {#if !hiddenControls[library.id]}
                            <li>
                                <input type="checkbox" class="collapse" id={library.id} bind:checked={unCollapsedControls[library.id]}>
                                <label class="link has-text-weight-bold" for={library.id}>
                                    {library.details.name}
                                </label>
                                {#if unCollapsedControls[library.id]}
                                    <ul>
                                        {#each [...library.categories] as category (category.id)}
                                        {#if !hiddenControls[category.id]}
                                        <li>
                                            <input type="checkbox" class="collapse" id="{category.id}" bind:checked={unCollapsedControls[category.id]}>
                                            <label class="link" for={category.id}>
                                                {category.details.name} ({category.details.control_number})
                                            </label>
                                            {#if unCollapsedControls[category.id]}
                                            <ul>
                                                {#each [...category.subcategories] as subcategory (subcategory.id)}
                                                {#if !hiddenControls[subcategory.id]}
                                                    <li>
                                                        <label class="link" for={subcategory.id}>
                                                            {subcategory.details.name} ({subcategory.details.control_number})
                                                        </label>
                                                        <ul>
                                                            {#each [...subcategory.controls] as control (control.id)}
                                                            {#if !hiddenControls[control.id]}
                                                                <li>
                                                                    <span
                                                                        class="link menu-item"
                                                                        draggable="true"
                                                                        on:dragstart={(evt) => dragStart(evt, library, control)}
                                                                        on:dragend={dragEnd}
                                                                    >
                                                                        <p><strong>{control.details.control_number} {control.details.name}</strong></p>
                                                                        {control.details.text}
                                                                    </span>
                                                                </li>
                                                            {/if}
                                                            {/each}
                                                        </ul>
                                                    </li>
                                                {/if}
                                                {/each}
                                            </ul>
                                            {/if}
                                        </li>
                                        {/if}
                                        {/each}
                                    </ul>
                                {/if}
                            </li>
                            {/if}
                        {/each}
                    </ul>
                </aside>
            </div>
        </div>
    </div>
</Loader>

<style>
    .menu {
        padding-bottom: 5em;
    }

    ul.menu-list, .collapse-all {
        line-height: 1.5em;
        font-family: Consolas, monaco, monospace;
    }

    .menu-list li ul {
        padding: .25em;
        margin: .25em;
    }

    .scroll {
        height: calc(100vh - 2.4em);
        overflow: auto;
    }

    .libs {
        position: fixed;
        width: inherit;
    }
    .column.card {
        margin: 10px;
        width: calc(25% - 20px);
    }

    .dragging .column.card * {
        pointer-events: none;
    }

    .mappings {
        margin-bottom: 1em;
    }

    .search {
        padding-right: .5em;
    }
</style>